module.exports = "/images/Contract_2.png?12f473f982121de9bcdefdd7ea530913";